var map = {
	"./chats/chats.module": [
		"./src/app/chats/chats.module.ts",
		"chats-chats-module"
	],
	"./knowledge/knowledge.module": [
		"./src/app/knowledge/knowledge.module.ts",
		"knowledge-knowledge-module"
	],
	"./manufactures-map/manufactures-map.module": [
		"./src/app/manufactures-map/manufactures-map.module.ts",
		"manufactures-map-manufactures-map-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return __webpack_require__.e(ids[1]).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;